export const TEAM_QUEUE = [
  'AI SOC',
  'Implementation',
  'DETENG',
  'MDR Engineering',
  'SOC',
  'SOC Engineering',
  'TAM',
  'VMP'
];

export default TEAM_QUEUE;
